<div
	[class.disabled-container]="isDisabled"
	[class.tag-input-appearance-form-control]="appearance === 'form-control'"
	class="tag-input-block position-relative"
	(ngClickOutside)="outsideClick($event)"
	(click)="markAsFocus($event)"
	(contextmenu)="markAsFocus($event)"
>
	<!-- Tag Input Container -->
	<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
	<div
		class="tag-input-container"
		#inputBlock
		[class]="uiModel.data.config.inputClass"
		[style.min-height.px]="uiModel.data.config.height"
	>
		<div class="row m-0 w-100">
			<div
				class="value-container pe-0 ps-1"
				#valueContainer
			>
				<ng-container>
					<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
					<div
						cdkDropListGroup
						class="cdk-drop-list scroll-bar py-1"
						(ngClickOutside)="uiModel.data.tagControl.activeTag = null!"
						[class.left-align]="uiModel.data.config.alignment === EnumNgAlignment.Left"
						[class.middle-align]="uiModel.data.config.alignment === EnumNgAlignment.Middle"
						[class.right-align]="uiModel.data.config.alignment === EnumNgAlignment.Right"
						[ngStyle]="{ 'overflow-y': 'auto', 'max-height': uiModel.data.config.height - 2.5 + 'px' }"
					>
						<div *ngFor="let item of uiModel.data.tagControl.selectedItems; let i = index">
							<div
								cdkDropList
								[cdkDropListData]="{ item: item, index: i }"
								cdkDropListOrientation="horizontal"
								(cdkDropListDropped)="moveItem($event)"
							>
								<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
								<div
									(dblclick)="onTagEdit(i)"
									#tagInputValue
									ngGrowOnMouseHover
									class="value cdk-drop-box px-1 disable-context-menu"
									tabindex="1"
									(click)="onTagFocused(i); onTagClick($event)"
									[cdkDragDisabled]="
										!uiModel.data.mode.draggable || uiModel.data.tagControl.activeTag === i
									"
									(cdkDragStarted)="onDragStart($event)"
									(cdkDragEnded)="onDragEnd()"
									(contextmenu)="disableContextMenu($event)"
									(mouseover)="hoveredElementIndex = i"
									(mouseout)="hoveredElementIndex = null"
									[ngStyle]="{
										'margin-left':
											hoveredElementIndex === i ? tagInputValue.offsetWidth * 0.03 + 'px' : null,
										'margin-right':
											hoveredElementIndex === i ? tagInputValue.offsetWidth * 0.03 + 'px' : null
									}"
									cdkDrag
								>
									<!-- Drag placeholder -->
									<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
									<div
										class="drag-placeholder row m-1"
										[ngStyle]="{
											'width.px': uiModel.data.dragPlaceholder.width,
											'height.px': uiModel.data.dragPlaceholder.height
										}"
										*cdkDragPlaceholder
									></div>

									<!-- Tag value -->
									<!-- Value-label class is using in css -->
									<span
										class="row m-0 value-label"
										tabindex="1"
										[attr.contenteditable]="uiModel.data.mode.edit ? true : false"
										(blur)="setAsBlur(i); uiModel.data.tagControl.activeTag = null!"
										(keyup.enter)="setAsBlur(i)"
										[textContent]="item"
									></span>

									<!-- Remove icon -->
									<span
										class="value-icon ps-1 text-muted"
										aria-hidden="true"
										*ngIf="
											uiModel.data.mode.remove &&
											uiModel.data.config.minTags < uiModel.data.tagControl.selectedItems.length
										"
										(click)="removeTag(i)"
									>
										<span class="remove-tag">
											<ng-fa-icon
												class="d-inline-flex"
												icon="xmark"
												[iconStyle]="EnumNgFaStyle.Regular"
											></ng-fa-icon>
										</span>
									</span>
								</div>
							</div>
						</div>

						<!-- Input field and dropdown block -->
						<div
							class="tag-input"
							[class.tag-input-flex]="uiModel.data.config.alignment === EnumNgAlignment.Left"
							*ngIf="
								uiModel.data.config?.maxTags! > uiModel.data.tagControl.selectedItems.length &&
								uiModel.data.mode.addNew
							"
							role="combobox"
							aria-haspopup="listbox"
							cdkDragDisabled="true"
						>
							<input
								#searchInput
								type="text"
								[class.text-center]="
									uiModel.data.config.alignment === EnumNgAlignment.Middle &&
									!uiModel.data.tagControl.selectedItems.length
								"
								(keydown)="onBackspace($event)"
								(keyup.enter)="
									this.isOpenSuggestion()
										? addSuggestion(getSuggestionList()[uiModel.data.tagControl.focusedElemIndex!])
										: addTags(searchInput.value)
								"
								[disabled]="
									uiModel.data.config.maxTags! > uiModel.data.tagControl.selectedItems.length &&
									uiModel.data.mode.addNew
										? false
										: true
								"
								(input)="keyStrokeEvent()"
								(click)="openSuggestionDropdown()"
								(input)="openSuggestionDropdown()"
								(keyup.ArrowUp)="arrowEvent(uiModel.data.tagControl.focusedElemIndex! - 1)"
								(keyup.ArrowDown)="arrowEvent(uiModel.data.tagControl.focusedElemIndex! + 1)"
								[placeholder]="
									uiModel.data.config.maxTags! > uiModel.data.tagControl.selectedItems.length &&
									uiModel.data.mode.addNew
										? ' ' + uiModel.data.config.hintText
										: ''
								"
							/>

							<!-- Inline dropdown block -->
							<div
								class="dropdown-block scroll-bar"
								#dropdownBlock
								*ngIf="
									isOpenSuggestion() &&
									uiModel.data.config.suggestion.type === EnumNgSuggestionType.Inline
								"
							>
								<ng-template [ngTemplateOutlet]="suggestionRef"></ng-template>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<!-- Filled dropdown block -->
	<div
		class="dropdown-block-filled scroll-bar"
		#dropdownBlock
		*ngIf="isOpenSuggestion() && uiModel.data.config.suggestion.type === EnumNgSuggestionType.Filled"
	>
		<ng-template [ngTemplateOutlet]="suggestionRef"></ng-template>
	</div>
</div>

<!-- Template ref for the suggestion dropdown -->
<ng-template #suggestionRef>
	<div
		class="option suggestion-option"
		role="button"
		*ngFor="let suggestion of getSuggestionList(); let i = index"
		[class.option-marked]="uiModel.data.tagControl.focusedElemIndex === i"
		(mouseover)="uiModel.data.tagControl.focusedElemIndex = i"
		(click)="addTags(suggestion)"
	>
		{{ suggestion }}
	</div>
</ng-template>
